import script from "./OperatorApplicationConfigNotifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationConfigNotifications.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationConfigNotifications.vue?vue&type=style&index=0&id=0ae6465c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae6465c"]])

export default __exports__